enum Studio {
    PRODUCTION_STUDIO = "PRODUCTION_STUDIO",
}

const GTM_IDS: Record<Studio, string> = {
    [Studio.PRODUCTION_STUDIO]: "GTM-PVJH95C3",
};

type GTMConfig = {
    dataLayerName?: string;
};

/**
 * Interface for window with data layer
 */
type WindowWithDataLayer = Record<string, unknown> & Window;

const getGTMIdForStudio = (studio: Studio) => {
    return GTM_IDS[studio];
};

const initializedGTMContainers = new Set<string>();

const isGTMInitialized = (id: string) => {
    return initializedGTMContainers.has(id);
};

const markGTMAsInitialized = (id: string) => {
    initializedGTMContainers.add(id);
};

export const initGTM = ({ dataLayerName = "wppopen_dataLayer" }: GTMConfig) => {
    const id = getGTMIdForStudio(Studio.PRODUCTION_STUDIO);
    if (isGTMInitialized(Studio.PRODUCTION_STUDIO)) {
        console.info(`GTM container ${id} already initialized, skipping.`);
        return;
    }

    // Initialize the data layer
    const windowWithDataLayer = window as unknown as WindowWithDataLayer;
    windowWithDataLayer[dataLayerName] = windowWithDataLayer[dataLayerName] ?? [];

    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','${dataLayerName}','${id}');`;

    if (document.head.firstChild) {
        document.head.insertBefore(script, document.head.firstChild);
    } else {
        document.head.appendChild(script);
    }

    markGTMAsInitialized(id);
};
